// import { useState } from 'react'
import SendMailComponentBlank from '../fragments/SendMailComponentBlank'
import SendSmsComponentBlank from '../fragments/SendSmsComponentBlank'
import classes from './IconBox.module.css'
import { phoneFormat } from '../../lib/script'
import BodySimpleModalV3 from '../common/modal/BodySimpleModalV3'

export default function IconBox({children, type, link, smsMail, fullInformation, ext, workq, small_blue}) {
    // const [showHelper, setShowhelper] = useState(false)
    // const mouseEnterHandler = () => {
    //     setShowhelper(true)
    // }
    // const mouseLeaveHandler = () => {
    //     setShowhelper(false)
    // }


    function copyTextHandler(text) {
        let htmlToCopy = text

        navigator.clipboard.writeText(htmlToCopy)
        // setShowhelper(false)
    }

    let messageHTML = <div className={classes.message}>
        <button title='copy' onClick={copyTextHandler.bind(this, link)}><i className="ti ti-copy"></i></button>
        <div className={classes.message_inner}>
            {/* {link} */}
            {(type== 'phone' || type == 'sms' || type == 'fax') && phoneFormat(link)}
            {(type == 'phone' && ext) && <>, ext: {ext}</>}
            {/* {type== 'fax' && link} */}
            {(type == 'mail') && link}
        </div>
    </div>

    return <BodySimpleModalV3 message={messageHTML}>
        <div className={`${classes.container} ${workq ? classes.workq_style : ''} ${small_blue ? classes.small_blue : ''}`} >
            {type== 'phone' && <a href={`tel:${link}${ext ? ','+ ext : ''}`}>
                {children}    
            </a>}

            {type== 'fax' && <a href={`tel:${link}`}>
                {children}    
            </a>}

            {type== 'sms' && <SendSmsComponentBlank phone={link} type={smsMail} data={fullInformation}>
                {children}
            </SendSmsComponentBlank>}

            {type== 'mail' && <SendMailComponentBlank mail={link} type={smsMail} data={fullInformation}>
                {children}
            </SendMailComponentBlank>}
        </div>
        
    </BodySimpleModalV3>

    // return <div className={`${classes.container} ${workq ? classes.workq_style : ''} ${small_blue ? classes.small_blue : ''}`} onMouseEnter={mouseEnterHandler} onMouseLeave={mouseLeaveHandler}>
    //     {type== 'phone' && <a href={`tel:${link}${ext ? ','+ ext : ''}`}>
    //         {children}    
    //     </a>}

    //     {type== 'fax' && <a href={`tel:${link}`}>
    //         {children}    
    //     </a>}

    //     {type== 'sms' && <SendSmsComponentBlank phone={link} type={smsMail} data={fullInformation}>
    //         {children}
    //     </SendSmsComponentBlank>}

    //     {type== 'mail' && <SendMailComponentBlank mail={link} type={smsMail} data={fullInformation}>
    //         {children}
    //     </SendMailComponentBlank>}

    //     {showHelper && <div className={classes.message}>
    //         <button title='copy' onClick={copyTextHandler.bind(this, link)}><i className="ti ti-copy"></i></button>
    //         <div className={classes.message_inner}>
    //             {/* {link} */}
    //             {(type== 'phone' || type == 'sms' || type == 'fax') && phoneFormat(link)}
    //             {(type == 'phone' && ext) && <>, ext: {ext}</>}
    //             {/* {type== 'fax' && link} */}
    //             {(type == 'mail') && link}
    //         </div>
    //     </div>}
    // </div>
}